import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';

interface AdminState {
  isAdminView: boolean;
}

const initialState: AdminState = {
  isAdminView: false,
};

export const adminSlice = createSlice<
  AdminState,
  SliceCaseReducers<AdminState>
>({
  name: 'admin',
  initialState,
  reducers: {
    setIsAdminView: (state, action: PayloadAction<boolean>) => {
      state.isAdminView = action.payload;
    },
  },
});

export const { actions: adminActions, reducer: adminReducer } = adminSlice;
